import Vue from "vue";
import Router from "vue-router";
import util from "../lib/util";
import { routes } from "./routes";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach((to, from) => {
  const routerNames = ["en", "cn", "m_en", "m_cn"];

  if (routerNames.indexOf(to.name) > -1 && from.name == null) {
    const is_cn = to.name.indexOf("cn") > -1;
    const os = util.getOs();
    const isMobile = os == "android" || os == "ios" || os == "wechat";
    let next_name = isMobile ? "m_" : "";
    next_name += is_cn ? "cn" : "en";
    router.push({ name: next_name }).catch(err => {
      console.log(err);
    });
  }
});

export default router;
